import { ActionTree } from 'vuex'
import * as types from './mutation-types'
import RootState from '@vue-storefront/core/types/RootState'
import IPayPaymentState from '../../types/IPayPaymentState'
import { processURLAddress } from '@vue-storefront/core/helpers'
import fetch from 'isomorphic-fetch'
import config from 'config'

const actions: ActionTree<IPayPaymentState, RootState> = {
  async initializeWidgetSession ({ commit }, payload) {
    let url = processURLAddress(config.ipay.get_widget_session_id_endpoint),
      firstItemProcessed = false
    Object.keys(payload).forEach(key => {
      let char = firstItemProcessed ? '&' : '?'
      url = `${url}${char}${key}=${payload[key]}`
    })
    await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(resp => resp.json())
    .then(resp => {
      commit(types.SET_WIDGET_SESSION_ID, resp.session)
      return resp
    })
    .catch(err => console.error(err))
  }
}

export default actions
